import { Component, Input, ViewChild } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { RagChatCompletionRequestModel } from 'src/app/core/models/aiChat/rag-chat-completion-request.model';
import { EntityFileModel } from 'src/app/core/models/file/entity-file-model';
import { Subject } from 'rxjs';
import { AIChatModalService } from 'src/app/core/services/modal-services/ai-chat-modal.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { AiApiService } from 'src/app/core/services/ai-api.service';
import { GlobalComponent } from 'src/app/global-component';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-tag-controller-modal',
  templateUrl: './tag-controller-modal.component.html',
  styleUrls: ['./tag-controller-modal.component.scss']
})
export class TagControllerModalComponent extends BaseModalComponent {

  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent | undefined;

  spinnerIsShown: boolean = false;
  minLengthTerm: number = 1;
  searchTerm: string | undefined;
  searchTerm$ = new Subject<string>();
  
  TagTermLength: number = 0;
  isPermittedTagListOpen: boolean = false;
  permittedTagList: string[] = GlobalComponent.defaultTagList;

  @Input() override model: EntityFileModel | any;

  constructor(
    protected aiApiService: AiApiService,
        protected override myFileApiService: MyfileApiService,
        protected override authMyFileService: AuthMyfileService,
        protected override modalRef: NgbActiveModal,
        protected override toasterNotificationService: ToasterNotificationService,
        protected override sanitizer: DomSanitizer,
  ){
    super(myFileApiService,authMyFileService,modalRef,toasterNotificationService,sanitizer);
  }
  
  override ngOnInit(): void {
    this.searchTerm$.subscribe(search => {
      if(search && search.length >0){
        this.searchTerm = search;
      }
    });
  }
  override ngOnDestroy(): void {

  }
  override validate(): boolean {
    throw new Error('Method not implemented.');
  }
  override onUpdate(): void {
    this.spinnerIsShown = true
    this.aiApiService.chatKnowledgeBaseLoad(this.model).subscribe((result)=>{
      this.spinnerIsShown = false;
      this.close();
    })
  }
  override onCreate(): void {
    throw new Error('Method not implemented.');
  }

  arrayCleared() {
    this.TagTermLength = 0;
    // this.settings.permittedTags = [];
  }

  accessTypeListController() {
    this.isPermittedTagListOpen = !this.isPermittedTagListOpen;
  }


  addTag(newTag: string) {
    if (newTag && newTag.length > 0) {
      this.TagTermLength = newTag.length;
      this.model.tags.push(`.${newTag}`)
    }
  }

  onBlurEvent(event: any){
    if(this.model.tags === undefined){
      this.model.tags = [];
    }
    if (event.target.value && event.target.value.length > 0) {
      this.TagTermLength = event.target.value.length;
      this.model.tags = [...this.model.tags, `${event.target.value}`];
      this.searchTerm$.next('');
      this.ngSelectComponent!.searchTerm = '';
      this.isPermittedTagListOpen = false;
    }
  }

  addCustomTag(tag: any) {
    return tag;
  }

  getBoolValue(bool: Boolean | undefined) {
    return bool as Boolean;
  }

  setBoolValue(event?: any): boolean {
    return event.target.checked as boolean;
  }

}
